import * as React from 'react';
import './index.scss';
import { Select, Button } from 'antd';
import dateFormat from 'dateformat';
import { requestDays } from '../../model/api';

const { Option } = Select;

export default class Mp extends React.Component{
  _weekday= ["星期日","星期一","星期二","星期三","星期四","星期五","星期六"];
  _SELECTED_LABEL = 'ABCDEFGHI';
  _MENU_MAX = 6;
  constructor(props) {
    super(props);
    this.state = {
      dates: []
    }
  }

  componentDidMount() {
    this.requestMenus();
  }

  requestMenus() {
    let start = dateFormat(new Date((new Date()).getTime() + 60 * 60 * 1000 * 24), 'yyyy-mm-dd')
    requestDays(start, 7, '1').then((days) => {
      if(days && days.code == 0 && days.data && days.data.length) {
        console.log(days);
        let dates = [];
        days.data.forEach((day) => {
          dates.push(day.day);
        })
        this.setState({dates});
      }
    })
  }

  render() {
    return (
      <div className="mp">
        <div className='mp-title'>菜单管理</div>
        <div className='mp-date'>
          {
            !!this.state.dates.length && (
              <>
                <span>日期</span>
                <Select value={this.state.dates[0]}>
                  {this.state.dates.map((day, i) => {
                    let curDate = new Date(day + "T00:00:00.000+08:00");
                    return (
                      <Option key={i} value={day}>{`${day} ${this._weekday[curDate.getDay()]}`}</Option>
                    )
                  })}
                </Select>
              </>
            )
          }
        </div>
        <div className='mp-menus'>
          <div className='mp-menus-label'>菜单</div>
          {Array(this._MENU_MAX).fill(0).map((_, i) => {
            
          })}
          <Button className='mp-submit'>提交菜单</Button>
        </div>
      </div>
    )
  }
}